// Danish free-text date parsing - used to opportunistically find an Event startDate where the CMS has no real date field.

const DANISH_MONTHS: Record<string, number> = {
	januar: 1,
	februar: 2,
	marts: 3,
	april: 4,
	maj: 5,
	juni: 6,
	juli: 7,
	august: 8,
	september: 9,
	oktober: 10,
	november: 11,
	december: 12,
};

// "25. december 2026" / "25 december 2026"
const DANISH_TEXT_DATE = /(\d{1,2})\.?\s+([a-zæøåA-ZÆØÅ]+)\s+(\d{4})/;
// "25-12-2026" / "25/12/2026" / "25.12.2026"
const NUMERIC_DATE = /(\d{1,2})[./-](\d{1,2})[./-](\d{4})/;

const toIsoDate = (year: number, month: number, day: number): string | undefined => {
	if (month < 1 || month > 12 || day < 1 || day > 31) return undefined;
	return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const parseDateFromText = (text: string | undefined): string | undefined => {
	if (!text) return undefined;

	const textMatch = text.match(DANISH_TEXT_DATE);
	if (textMatch) {
		const [, day, monthName, year] = textMatch;
		const month = DANISH_MONTHS[monthName.toLowerCase()];
		if (month) return toIsoDate(Number(year), month, Number(day));
	}

	const numericMatch = text.match(NUMERIC_DATE);
	if (numericMatch) {
		const [, day, month, year] = numericMatch;
		return toIsoDate(Number(year), Number(month), Number(day));
	}

	return undefined;
};
